import Plus from 'baseui/icon/plus';
import { themedStyled } from 'common/styles/styletron.theme';
import { SeparatorHorizontal } from 'legacy-modules/styles';

interface CreateSelectComponentProps {
  label: string;
  onCreate?: () => void;
}

export default function CreateSelectComponent(
  props: CreateSelectComponentProps,
) {
  const { onCreate, label } = props;
  return (
    <ActionContainer onClick={onCreate}>
      <Plus size={20} />
      <SeparatorHorizontal $margin={4} />
      {label}
    </ActionContainer>
  );
}

const ActionContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'blue',
  cursor: 'pointer',
  height: '100%',
  width: '100%',
  position: 'absolute',
  inset: 0,
});
